// frontend/src/hooks/useScrollSpy.js
import { useEffect, useState } from 'react';

export default function useScrollSpy(sectionIds, { rootMargin = '-30% 0px -60% 0px' } = {}) {
    const [activeId, setActiveId] = useState(sectionIds[0] || '');

    useEffect(() => {
        if (!sectionIds.length) return;
        const observer = new IntersectionObserver(
            (entries) => {
                const visible = entries
                    .filter((e) => e.isIntersecting)
                    .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
                if (visible[0]) setActiveId(visible[0].target.id);
            },
            { rootMargin, threshold: [0, 0.25, 0.5, 0.75, 1] }
        );
        const els = sectionIds.map((id) => document.getElementById(id)).filter(Boolean);
        els.forEach((el) => observer.observe(el));
        return () => observer.disconnect();
    }, [sectionIds.join('|'), rootMargin]); // eslint-disable-line

    return activeId;
}// JavaScript source code
